export default {
  subtitle: "Brazilian Bank Accounts",
  path: "bank_accounts_br",
  paragraphs: [
    "Your Brazilian Bank Account will be available within your credentials and your Portal. You can always check it in Bank Accounts > FacilitaPay Payin accounts.",
    "To add your customer's bank account in Brazil, use the endpoint below. Replace :id with the subject_id:"
  ],
  request: {
    method: "POST",
    endpoint: "/subject/:id/bank_accounts",
    payload: {
      "bank_account": {
        "account_type": "conta-corrente",
        "account_number": "85296",
        "branch_number": "0031",
        "owner_document_number": "01472583691",
        "owner_document_type": "cpf",
        "owner_name": "André Freitas Lopes",
        "branch_country": "BRA",
        "bank": {
          "code": "031",
          "name": "Banco do Estado de Minas Gerais"
        },
        "pix_info": {
          "type": "CPF",
          "key": "01472583691"
        },
        "currency": "BRL",
      }
    },
    responses: {
      "data": {
        "routing_number": "001587951",
        "owner_name": "André Freitas Lopes",
        "owner_document_number": "01472583691",
        "owner_document_type": "cpf",
        "owner_company": {
          "social_name": "André Freitas Lopes",
          "id": "a1f3a3a9-ad04-4450-aeee-c28e92c597a9",
          "document_type": "CPF",
          "document_number": "01472583691"
        },
        "intermediary_bank_account": null,
        "id": "a3728935-d046-4fd9-a995-0b80c7807ed6",
        "currency": "BRL",
        "branch_number": "0031",
        "branch_country": "BRA",
        "iban": null,
        "nickname": null,
        "bank": {
          "swift": null,
          "ispb": null,
          "name": "Banco do Estado de Minas Gerais",
          "id": "f9dcd833-a4a8-4595-8f5a-b63b0a98292d",
          "code": "031",
          "country": "BRA",
        },
        "pix_info": {
          "type": "CPF",
          "key": "0147258369"
        },
        "account_type": "conta-corrente",
        "account_number": "85296",
        "aba": null
      }
    }
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "Customer UUID"
    }
  ],
  parameterPayload: [
    {
      name: "bank_account",
      type: "object",
      required: true,
      description: "An object containing:",
      is_parent: true
    },
    {
      name: "bank_account.account_number",
      type: "string",
      required: false,
      description: "Account number",
      requiredFor: "bank account with full bank details"
    },
    {
      name: "bank_account.branch_number",
      type: "string",
      required: false,
      description: "Account branch number",
      requiredFor: "bank account with full bank details"
    },
    {
      name: "bank_account.owner_name",
      type: "string",
      required: true,
      description: "Account owner full name",
    },
    {
      name: "bank_account.currency",
      type: "string",
      required: true,
      description: "Account currency (ISO 4217 format)",
    },
      {
      name: "bank_account.pix_info",
      type: "object",
      required: false,
      description: "PIX information associated with the bank account. If you want to make a payment via PIX for your customers, you will need to send this object.",
      is_parent: true,
      requiredFor: "bank account with only pix information"
    },
    {
      name: "bank_account.pix_info.type",
      type: "string",
      required: false,
      description: "Type of PIX key (e.g., CPF, CNPJ) the field value must be passed in uper case as shown in the example. Only required when pix_info is given.",
      requiredFor: "bank account with only pix information"
    },
    {
      name: "bank_account.pix_info.key",
      type: "string",
      required: false,
      description: "PIX key value associated with the bank account. Only required when pix_info is given.",
      requiredFor: "bank account with only pix information"
    },
    {
      name: "bank_account.bank",
      type: "object",
      required: false,
      description: "An object containing information from the bank which the account belongs:",
      is_parent: true,
      requiredFor: "bank account with full bank details"
    },
    {
      name: "bank_account.bank.code",
      type: "string",
      required: false,
      description: "Bank code in Brazil (3 digits). You can also use the ispb field below to identify a bank instead of the code.",
      requiredFor: "bank account with full bank details"
    },
    {
      name: "bank_account.bank.ispb",
      type: "string",
      required: false,
      description: "An 8-digit code that identifies the bank in the Brazilian payments system. It can dismiss the use of the 3-digit code.",
      requiredFor: "bank account with full bank details"
    },
    {
      name: "bank_account.bank.name",
      type: "string",
      required: false,
      description: "Bank name²",
      requiredFor: "bank account with full bank details"
    },
    {
      name: "bank_account.account_type",
      type: "string",
      required: false,
      description: "Account type. Some banks distinguish between checking (conta corrente) and savings (poupanca) accounts.",
    },
    {
      name: "bank_account.owner_document_number",
      type: "string",
      required: false,
      description: "Document number for the account owner",
    },
    {
      name: "bank_account.owner_document_type",
      type: "string",
      required: false,
      description: "cpf or cnpj (downcase)",
    },
    {
      name: "bank_account.branch_country",
      type: "String",
      required: false,
      description: "An ISO 3166-1 alpha-3 country code of the account country",
    }
  ],
  footerNotes: "¹CPF and CNPJ are unique identification codes for Brazilian citizens and companies, respectively, and are used to track tax information and other identification purposes by the government. They are analog to the SSN - Social Security Number or CURP, for Mexico. ²If a previously registered bank code or ispb is provided, its corresponding name will be overwritten with the recorded in our database. ³If you need to register your customer bank account using only pix, you can delete the bank object, account_type, account_number and branch_number from the body",
  troubleshooting: {
    title: 'Common mistakes',
    messages: [
      {
        description: 'Not providing a person or company ID, or providing an invalid one',
        code: {
          "error": "not_found"
        },
        solution: 'Provide a valid UUID. Remember to format all characters in lowercase.'
      },

       {
        description: 'Invalid Pix key passed',
        code:{
              "errors": {
                  "pix_info": [
                      "invalid key"
                  ]
              }
          },
        solution: 'Provide a valid valid pix key, this can be a CPF, CNPJ, EMAIL, PHONE or a EVP (Virtual Payment Address) a 32 characters (letters and numbers).'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/BankAccount/BankAccountsRegistrationBR.js